/**
 * FH-A11Y batch 2026-09-26 — audit items 3, 5, 6, 8, 9, 10, 13, 14 (search cards), 15, 16, 17, 18, 20;
 * batch 2 (same day): items 24, 25, 26, 34, 35 from the user-journey audit; batch 3: items 27, 29, 31, 36; batch 5: skip-link fix; batch 6: heading levels (14/33); batch 7: review photos.
 * Every fix is idempotent and re-applied (debounced) when apps or sliders change the page.
 * Rollback: remove the three FH-A11Y batch lines at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch) return;
  window.__fhA11yBatch = true;

  var FOCUSABLE = 'a[href], button, input, select, textarea, summary, [tabindex]';
  var path = location.pathname.replace(/^\/(fr|de)(?=\/|$)/, '') || '/';

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }

  /* Items 3, 8, 16, 20: Slick sliders (home Bestsellers + blog, product gallery + thumbnails). */
  function fixSliders() {
    // Item 3: ada-a11y-fixes.js already turns slider items into role=presentation (Block L).
    // A list whose items are all presentational must not itself claim to be a list.
    document.querySelectorAll('ul[id^="Slider-template-"], ol[id^="Slider-template-"]').forEach(function (list) {
      var items = list.querySelectorAll('li');
      if (!items.length) return;
      var allPresentational = Array.prototype.every.call(items, function (li) {
        return /^(presentation|none)$/.test(li.getAttribute('role') || '');
      });
      if (!allPresentational) return;
      setAttr(list, 'role', 'presentation');
      removeAttr(list, 'aria-label'); // a label on a presentational element conflicts with the role
      Array.prototype.forEach.call(items, function (li) {
        if (li.getAttribute('aria-hidden') === 'false') li.removeAttribute('aria-hidden'); // same default, no conflict
      });
    });
    document.querySelectorAll('.slick-initialized').forEach(function (root) {
      root.querySelectorAll('.slick-slide').forEach(function (slide) {
        // Slides were an extra tab stop.
        removeAttr(slide, 'tabindex');
        var hidden = slide.getAttribute('aria-hidden') === 'true';
        slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
          if (hidden) {
            if (!el.hasAttribute('data-ada-prev-ti')) {
              el.setAttribute('data-ada-prev-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
            }
            setAttr(el, 'tabindex', '-1');
          } else if (el.hasAttribute('data-ada-prev-ti')) {
            var prev = el.getAttribute('data-ada-prev-ti');
            el.removeAttribute('data-ada-prev-ti');
            if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
          }
        });
        // Headings / images are not controls: no tab stop.
        slide.querySelectorAll('h1[tabindex],h2[tabindex],h3[tabindex],h4[tabindex],h5[tabindex],h6[tabindex],img[tabindex]').forEach(function (el) {
          if (!el.hasAttribute('data-ada-prev-ti')) el.removeAttribute('tabindex');
        });
      });
    });
  }

  /* Item 9: collection hero slideshow is a scroll container keyboard users cannot reach. */
  function fixSlideshowScroll() {
    document.querySelectorAll('[id^="Slider-"][id*="__slideshow"]').forEach(function (el) {
      if (el.querySelectorAll('.slideshow__slide').length <= 1) {
        if (el.style.overflowX !== 'hidden') { el.style.overflowX = 'hidden'; el.style.overflowY = 'hidden'; }
      } else if (el.scrollWidth > el.clientWidth + 1) {
        setAttr(el, 'tabindex', '0');
        setAttr(el, 'role', 'region');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Slideshow');
      }
    });
  }

  /* Item 10: Rivyo review photos use file-style alt text ("Deck rug_image_0"). */
  function fixReviewPhotos() {
    document.querySelectorAll('.wc_review_media_box img, [class*="wc_review_media"] img, .wc_rivyoMedia img').forEach(function (img) {
      var alt = img.getAttribute('alt') || '';
      var m = alt.match(/^(.*)_image_\d+$/);
      if (!m) return;
      var title = m[1].replace(/_/g, ' ').trim();
      img.setAttribute('alt', /^\d*$/.test(title) ? 'Customer photo' : 'Customer photo: ' + title);
    });
  }

  /* Item 13: every page gets one level-1 heading. */
  var h1Done = false;
  function fixPageHeading() {
    if (h1Done) return;
    var main = document.querySelector('main') || document.getElementById('MainContent');
    if (!main) return;
    if (main.querySelector('h1, [role="heading"][aria-level="1"], h2[aria-level="1"]')) { h1Done = true; return; }
    var first = main.querySelector('h2.banner__heading, h2.ecom-shopify__article--title-text');
    if (first && first.getClientRects().length) {
      first.setAttribute('aria-level', '1');
    } else if (/^\/blogs\/[^/]+\/?$/.test(path)) {
      var h1 = document.createElement('h1');
      h1.className = 'ada-visually-hidden-h1';
      h1.textContent = document.title.split(' – ')[0].trim();
      main.insertBefore(h1, main.firstChild);
    } else {
      return; // nothing suitable yet (content may still be loading)
    }
    h1Done = true;
  }

  /* Item 14 (search page): result card titles follow the page h1, so they are level 2. */
  function fixSearchCardHeadings() {
    if (!/^\/search/.test(path)) return;
    document.querySelectorAll('#product-grid h3.card__heading').forEach(function (h) { setAttr(h, 'aria-level', '2'); });
  }

  /* Item 15: the bare counter number ("279") is not a heading. */
  function fixCounterHeading() {
    document.querySelectorAll('h2.counter_number_total').forEach(function (h) { setAttr(h, 'role', 'none'); });
  }

  /* Item 17: Globo filter options had two tab stops (the option and a link inside it). */
  function fixFilterOptions() {
    document.querySelectorAll('.gf-filter-contents li[role="checkbox"] a, .gf-filter-contents li[role="radio"] a').forEach(function (a) {
      setAttr(a, 'tabindex', '-1');
    });
  }

  /* Item 18: Globo search box has only a placeholder as its name. */
  function fixSearchInputLabel() {
    var input = document.getElementById('gl-d-searchbox-input');
    if (input && !input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Search products');
  }

  /* Item 6: when the Globo search pop-up closes, return focus to where the user was. */
  var lastOutside = null;
  var popupWasOpen = false;
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest('.gl-fullscreen-layer, #glFilter-search-popup, .glFilter-search-popup')) lastOutside = e.target;
  }, true);
  function fixSearchPopupFocusReturn() {
    var open = !!document.querySelector('.gl-fullscreen-layer, #glFilter-search-popup');
    if (popupWasOpen && !open) {
      var a = document.activeElement;
      if ((!a || a === document.body || !a.getClientRects().length) && lastOutside) {
        // Never refocus a search box (that re-opens the pop-up); use the search toggle that opened it instead.
        var isField = /^(INPUT|TEXTAREA)$/.test(lastOutside.tagName);
        var details = lastOutside.closest && lastOutside.closest('details');
        var candidates = isField
          ? [details && details.querySelector('summary'), document.querySelector('summary.header__icon--search')]
          : [lastOutside, document.querySelector('summary.header__icon--search')];
        for (var i = 0; i < candidates.length; i++) {
          var c = candidates[i];
          if (c && document.contains(c) && c.getClientRects().length) { c.focus(); if (document.activeElement === c) break; }
        }
      }
    }
    popupWasOpen = open;
  }

  /* Item 5: mobile menu drawer keeps focus inside while open; Escape always closes it. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.key !== 'Escape') return;
    var details = document.querySelector('details.menu-drawer-container[open]');
    if (!details) return;
    var summary = details.querySelector('summary');
    var drawer = document.getElementById('menu-drawer');
    if (!summary || !drawer || !drawer.getClientRects().length) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      var hd = details.closest('header-drawer');
      if (hd && typeof hd.closeMenuDrawer === 'function') hd.closeMenuDrawer(e, summary);
      else summary.click();
      summary.focus();
      return;
    }
    if (!details.classList.contains('menu-opening')) return; // drawer is closing: leave Tab alone
    var items = [summary].concat(Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.tabIndex >= 0 && !el.disabled && el.getClientRects().length && !el.closest('[hidden], [aria-hidden="true"]');
    }));
    if (items.length < 2) return; // nothing reachable in the drawer yet: never trap focus on the toggle alone
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (items.indexOf(active) === -1) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }, true);

  /* Item 24 (batch 2): the chat launcher was a mouse-only div. Make it a named button that opens chat
     from the keyboard, moves focus into the chat, and returns focus to the launcher when chat closes. */
  var chatBound = false;
  function fixChatLauncher() {
    var box = document.getElementById('freshdeskwidgetcontainer');
    if (!box || chatBound) return;
    chatBound = true;
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', 'Chat with us');
    Array.prototype.forEach.call(box.children, function (c) { c.setAttribute('aria-hidden', 'true'); });
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      box.click(); // the theme's own handler loads Freshchat
      var tries = 0;
      (function openWhenReady() {
        var w = window.fcWidget;
        if (w && typeof w.isInitialized === 'function' && w.isInitialized()) {
          w.open();
          // Move focus into the chat once it is showing, then watch for it closing to bring focus back.
          var n = 0;
          (function focusChat() {
            var f = document.querySelector('#fc_frame iframe');
            if (f) f.focus();
            if ((!f || document.activeElement !== f) && n++ < 12) setTimeout(focusChat, 250);
          })();
          var seenOpen = false, ticks = 0;
          var watch = setInterval(function () {
            if (typeof w.isOpen !== 'function') { clearInterval(watch); return; }
            if (w.isOpen()) { seenOpen = true; return; }
            if (!seenOpen) { if (++ticks > 20) clearInterval(watch); return; }
            clearInterval(watch); // chat was open and is now closed
            var a = document.activeElement;
            if (!a || a === document.body || (a.tagName === 'IFRAME' && a.closest('#fc_frame'))) box.focus();
          }, 500);
        } else if (tries++ < 40) {
          setTimeout(openWhenReady, 250);
        }
      })();
    });
  }

  /* Item 25/26 (batch 2): contact form (Globo Form Builder) fields: required state, autofill hints,
     error messages tied to their fields and announced. Focus ring is in ada-a11y-batch.css. */
  var AUTO = { text: ['name', ''], email: ['email', 'email'], phone: ['tel', 'tel'] };
  function fixContactForm() {
    document.querySelectorAll('form.g-container').forEach(function (form) {
      form.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(function (el) {
        var label = el.id && form.querySelector('label[for="' + el.id + '"]');
        var star = label && label.querySelector('.text-danger');
        if (star) {
          setAttr(el, 'aria-required', 'true');
          setAttr(star, 'aria-hidden', 'true');
        }
        var a = AUTO[el.name];
        if (a && !el.getAttribute('autocomplete')) {
          el.setAttribute('autocomplete', a[0]);
          if (a[1]) el.setAttribute('inputmode', a[1]);
        }
        var err = el.id && document.getElementById(el.id + '-error');
        if (err) {
          setAttr(err, 'aria-live', 'polite');
          var ids = (el.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
          if (ids.indexOf(err.id) === -1) { ids.push(err.id); el.setAttribute('aria-describedby', ids.join(' ')); }
          var hasErr = !!err.textContent.trim();
          if (hasErr) setAttr(el, 'aria-invalid', 'true'); else removeAttr(el, 'aria-invalid');
        }
      });
    });
  }

  /* Item 34 (batch 2): cart button read "Cart Icon, Cart, 0 items"; the icon image is decorative. */
  function fixCartIcon() {
    document.querySelectorAll('#cart-icon-bubble .cart-icon img').forEach(function (img) { setAttr(img, 'alt', ''); });
  }

  /* Item 35 (batch 2): the founders' photo on About had empty alt. */
  function fixFoundersPhoto() {
    if (!/^\/pages\/about/.test(path)) return;
    document.querySelectorAll('main img[src*="our_story_1"]').forEach(function (img) {
      if (!img.getAttribute('alt')) img.setAttribute('alt', 'Fab Habitat’s founders');
    });
  }

  /* Item 27 (batch 3): blog "shop the look" cards have "Choose options" buttons whose pop-up isn't on the
     page, so they do nothing. Hide only the broken ones; the product link on the card still works. */
  function fixDeadQuickAdd() {
    document.querySelectorAll('modal-opener[data-modal]').forEach(function (m) {
      var sel = m.getAttribute('data-modal');
      var target = null;
      try { target = sel && document.querySelector(sel); } catch (e) {}
      if (target) return;
      var box = m.closest('.quick-add') || m;
      if (!box.hasAttribute('hidden')) box.setAttribute('hidden', '');
    });
  }

  /* Item 29 (batch 3, changed in batch 5): the menu app adds a second skip link right after the theme's own.
     Batch 3 hid it with [hidden], which WAVE reports as a "Broken skip link" (a skip link keyboard users can't
     reach). Remove it from the page instead; the theme's own "Skip to content" link stays. */
  function fixDuplicateSkipLink() {
    if (!document.querySelector('a.skip-to-content-link')) return;
    document.querySelectorAll('a.tmenu_skip-link').forEach(function (a) {
      if (a.parentNode) a.parentNode.removeChild(a);
    });
  }

  /* Item 31 (batch 3): blog share links were named "facebook", "twitter", "email" and open a new tab unannounced. */
  var SHARE = { facebook: 'Share on Facebook', twitter: 'Share on X (Twitter)', pinterest: 'Share on Pinterest', email: 'Share by email' };
  function fixShareLinks() {
    document.querySelectorAll('a.element-social-link').forEach(function (a) {
      var key = (a.getAttribute('alt') || a.getAttribute('aria-label') || '').toLowerCase();
      if (!SHARE[key]) return;
      var newTab = a.target === '_blank' && !/^mailto:/i.test(a.getAttribute('href') || '');
      setAttr(a, 'aria-label', SHARE[key] + (newTab ? ' (opens in new tab)' : ''));
      if (/^mailto:/i.test(a.getAttribute('href') || '')) removeAttr(a, 'target');
    });
  }

  /* Item 36 (batch 3): blog index cards had an image link and a title link to the same post, and the
     category filter didn't say which category is shown. */
  function fixBlogIndex() {
    if (!/^\/blogs\/[^/]+\/?$/.test(path)) return;
    document.querySelectorAll('a.ecom-shopify__blog--post-link.ecom-image-default').forEach(function (a) {
      var href = a.getAttribute('href');
      var card = a.parentElement;
      for (var i = 0; i < 6 && card; i++) {
        var twin = Array.prototype.filter.call(card.querySelectorAll('a[href]'), function (x) {
          return x !== a && x.getAttribute('href') === href && (x.textContent || '').trim();
        })[0];
        if (twin) { setAttr(a, 'tabindex', '-1'); setAttr(a, 'aria-hidden', 'true'); break; }
        card = card.parentElement;
      }
    });
    var here = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('a.ecom-shopify__blog--categories-item-link, a.ecom-iconlist--container').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (h && h === here.replace(/^\/(fr|de)(?=\/)/, '')) setAttr(a, 'aria-current', 'page');
    });
  }

  /* Item 14/33 (batch 6): heading levels that skipped. Visual styles are unchanged; only the level announced
     to screen readers changes. */
  function fixHeadingLevels() {
    // Contact form title from Globo Form Builder: h3 directly under the page h1.
    document.querySelectorAll('.globo-formbuilder h3.globo-heading').forEach(function (h) { setAttr(h, 'aria-level', '2'); });
    // Blog posts (EComposer). Article body headings start at h3: shift the whole body so its top level is 2.
    if (!/^\/blogs\/[^/]+\/[^/]+/.test(path)) return;
    document.querySelectorAll('.ecom-shopify__article__description--paragraph, .ecom-shopify__article__description').forEach(function (body) {
      var hs = body.querySelectorAll('h2, h3, h4, h5, h6');
      if (!hs.length) return;
      var min = 6;
      Array.prototype.forEach.call(hs, function (h) { min = Math.min(min, +h.tagName[1]); });
      if (min <= 2) return;
      Array.prototype.forEach.call(hs, function (h) {
        if (h.closest('.product-card')) return;
        setAttr(h, 'aria-level', String(+h.tagName[1] - (min - 2)));
      });
    });
    // "Shop the look" product cards: the name is a sub-heading; the price is not a heading at all.
    document.querySelectorAll('.product-card h1, .product-card h2, .product-card h3, .product-card h4, .product-card h5, .product-card h6').forEach(function (h) {
      if (h.classList.contains('product-item-name')) setAttr(h, 'aria-level', '3');
      else if (/^[\s$€£\d.,–-]+$/.test(h.textContent || '')) setAttr(h, 'role', 'none');
    });
    // Sidebar section titles ("Latest Posts", "Categories") are h6.
    document.querySelectorAll('h6.ecom__heading').forEach(function (h) { setAttr(h, 'aria-level', '2'); });
  }

  /* Batch 7: Rivyo review photo gallery. (a) Photos with no usable title all read "Customer photo", which WAVE
     flags as nearby images with the same alt text: number them ("Customer photo 2 of 4: Deck rug").
     (b) The photos open a larger view on click but couldn't be reached by keyboard: make each a button.
     (c) The larger view had no dialog role, unnamed Next/Close buttons, no Escape and no focus handling. */
  var photoOpener = null;
  var photoOpenerIndex = -1;
  var photoModalSeen = false;
  function fixReviewGallery() {
    document.querySelectorAll('.wc_review_media_gallery').forEach(function (g) {
      var boxes = g.querySelectorAll('.wc_review_media_box');
      var n = boxes.length;
      Array.prototype.forEach.call(boxes, function (box, i) {
        var img = box.querySelector('img');
        if (img) {
          if (!img.hasAttribute('data-fh-base')) {
            var alt = img.getAttribute('alt') || '';
            var m = alt.match(/^(.*)_image_\d+$/);
            var t = m ? m[1].replace(/_/g, ' ').trim() : alt.replace(/^Customer photo(\s+\d+\s+of\s+\d+)?:?\s*/, '').trim();
            if (/^\d*$/.test(t)) t = '';
            img.setAttribute('data-fh-base', t);
          }
          var base = img.getAttribute('data-fh-base');
          setAttr(img, 'alt', 'Customer photo ' + (i + 1) + ' of ' + n + (base ? ': ' + base : ''));
        }
        setAttr(box, 'role', 'button');
        setAttr(box, 'tabindex', '0');
        setAttr(box, 'aria-haspopup', 'dialog');
        if (!box.__fhPhotoKey) {
          box.__fhPhotoKey = true;
          box.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
            e.preventDefault();
            photoOpener = box;
            photoOpenerIndex = Array.prototype.indexOf.call(document.querySelectorAll('.wc_review_media_gallery .wc_review_media_box'), box);
            box.click();
          });
          box.addEventListener('click', function () {
            photoOpener = box;
            photoOpenerIndex = Array.prototype.indexOf.call(document.querySelectorAll('.wc_review_media_gallery .wc_review_media_box'), box);
          });
        }
      });
    });
  }
  function fixReviewModal() {
    var m = document.querySelector('.wc_rivyo_modal');
    if (!m) {
      if (photoModalSeen) {
        photoModalSeen = false;
        var a = document.activeElement;
        // Rivyo re-renders the gallery when the photo view closes, so find the opener again by its position.
        var back = photoOpener && document.contains(photoOpener) ? photoOpener
          : (photoOpenerIndex >= 0 ? document.querySelectorAll('.wc_review_media_gallery .wc_review_media_box')[photoOpenerIndex] : null);
        if (back && (!a || a === document.body)) back.focus();
      }
      return;
    }
    var d = m.querySelector('.wc_rivyo_modal_dialog') || m;
    setAttr(d, 'role', 'dialog');
    setAttr(d, 'aria-modal', 'true');
    setAttr(d, 'aria-label', 'Customer photo');
    var close = m.querySelector('.wc_rivyo_modal_close');
    if (close) setAttr(close, 'aria-label', 'Close');
    m.querySelectorAll('.wc_rivyo_modal_btn').forEach(function (b) {
      var prev = /^pre/i.test(b.getAttribute('data-type') || '') || b.classList.contains('wc_rivyo_prev');
      setAttr(b, 'aria-label', prev ? 'Previous photo' : 'Next photo');
    });
    m.querySelectorAll('button svg').forEach(function (s) { setAttr(s, 'aria-hidden', 'true'); });
    if (!photoModalSeen) {
      photoModalSeen = true;
      if (close) setTimeout(function () { close.focus(); }, 50);
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Tab') return;
    var m = document.querySelector('.wc_rivyo_modal');
    if (!m) return;
    var d = m.querySelector('.wc_rivyo_modal_dialog') || m;
    if (e.key === 'Escape') {
      var close = m.querySelector('.wc_rivyo_modal_close');
      if (close) { e.preventDefault(); close.click(); }
      return;
    }
    var items = Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && !el.disabled && el.getClientRects().length && getComputedStyle(el).display !== 'none';
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!d.contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }, true);

  function runAll() {
    try { fixSliders(); } catch (e) {}
    try { fixSlideshowScroll(); } catch (e) {}
    try { fixReviewPhotos(); } catch (e) {}
    try { fixPageHeading(); } catch (e) {}
    try { fixSearchCardHeadings(); } catch (e) {}
    try { fixCounterHeading(); } catch (e) {}
    try { fixFilterOptions(); } catch (e) {}
    try { fixSearchInputLabel(); } catch (e) {}
    try { fixSearchPopupFocusReturn(); } catch (e) {}
    try { fixChatLauncher(); } catch (e) {}
    try { fixContactForm(); } catch (e) {}
    try { fixCartIcon(); } catch (e) {}
    try { fixFoundersPhoto(); } catch (e) {}
    try { fixDeadQuickAdd(); } catch (e) {}
    try { fixDuplicateSkipLink(); } catch (e) {}
    try { fixShareLinks(); } catch (e) {}
    try { fixBlogIndex(); } catch (e) {}
    try { fixHeadingLevels(); } catch (e) {}
    try { fixReviewGallery(); } catch (e) {}
    try { fixReviewModal(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'role', 'alt']
    });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
